import { OPTIBAY_STAGES, OPTIBAY_STAGE_LABELS, type OptiBayStage } from '@/types/optibay';
import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';

interface OptiBayStageTrackerProps {
  currentStage: OptiBayStage;
  onStageClick?: (stage: OptiBayStage) => void;
}

export function OptiBayStageTracker({ currentStage, onStageClick }: OptiBayStageTrackerProps) {
  const currentIndex = OPTIBAY_STAGES.indexOf(currentStage);

  return (
    <div className="flex items-center gap-1 overflow-x-auto py-2 px-1 scrollbar-none">
      {OPTIBAY_STAGES.map((stage, i) => {
        const isComplete = i < currentIndex;
        const isCurrent = stage === currentStage;
        const isFuture = i > currentIndex;
        const canClick = isComplete && onStageClick;

        return (
          <div key={stage} className="flex items-center shrink-0">
            {i > 0 && (
              <div className={cn(
                'w-4 h-px mx-0.5',
                isComplete ? 'bg-primary' : 'bg-border'
              )} />
            )}
            <button
              type="button"
              disabled={!canClick}
              onClick={() => canClick && onStageClick(stage)}
              className={cn(
                'flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium transition-colors whitespace-nowrap',
                isComplete && 'bg-primary/10 text-primary cursor-pointer hover:bg-primary/20',
                isCurrent && 'bg-primary text-primary-foreground',
                isFuture && 'bg-muted text-muted-foreground',
                !canClick && !isCurrent && 'cursor-default',
              )}
            >
              {isComplete && <Check className="h-3 w-3" />}
              {OPTIBAY_STAGE_LABELS[stage]}
            </button>
          </div>
        );
      })}
    </div>
  );
}
